import {
  Box,
  Button,
  Grid,
  GridItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";

export default function AddCart({ isOpen, onClose, name, qty, img }) {
  const [mobile] = useMediaQuery("(max-width: 600px)");

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Berhasil Ditambahkan</ModalHeader>
        <ModalCloseButton />
        <hr />
        <ModalBody>
          <Grid
            borderRadius="10px"
            border="1px solid #E0E0E0"
            width="full"
            templateColumns={mobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"}
            p="5"
            my="3"
          >
            <GridItem colSpan={2} display="flex">
              <img
                src={img}
                alt="Logo"
                style={{
                  borderRadius: "5px",
                  maxWidth: "200px",
                  maxHeight: "200px",
                }}
              />
              <Box
                display="flex"
                justifyContent="center"
                flexDirection="column"
                px="4"
                width="full"
              >
                <Text fontWeight="500" fontSize="20">
                  {name}
                </Text>
                <Text fontWeight="400" fontSize="12">
                  jumlah {qty}
                </Text>
              </Box>
            </GridItem>
            <GridItem
              display="flex"
              alignItems="center"
              pt={mobile && "2"}
              justifyContent={mobile ? "center" : "flex-end"}
            >
              <Link to="/keranjang">
                <Button variant="solid" width="full" colorScheme="blue" px="7">
                  Lihat Keranjang
                </Button>
              </Link>
            </GridItem>
          </Grid>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
